import { VStack, HStack, ScrollView, Pressable } from "@gluestack-ui/themed";

import { ButtonGroup } from "@repo/core/components/core/ButtonGroup";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";

import { Input } from "@repo/core/components/core/Input";

import { filterStatusOptions } from "./consts";
import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { ProposalsSearchHeaderProps } from "./types";

import useFilterStore from "@repo/core/stores/proposals-filters";
import { useMemo, useState } from "react";
import { useDimensions } from "@repo/core/hooks/useDimensions";

export const CreditTableHeader = ({
  onRefresh
}: ProposalsSearchHeaderProps) => {
  const [currentValue, setCurrentValue] = useState("");

  const { filters, setFilters } = useFilterStore();
  const { isTablet } = useDeviceType();
  const { isMobile } = useDimensions();

  const inputSearchRightIcon = {
    name: "magnifying-glass",
    onPress: () => {
      setFilters({ text: currentValue });
    }
  };

  const headerContentWidth = useMemo(() => {
    if (isTablet) return "80%";
    if (isMobile) return "$full";

    return "50%";
  }, [isMobile, isTablet]);

  return (
    <VStack
      width="$full"
      alignItems="center"
      justifyContent="center"
      py="$6"
      px="$4"
      bg="$primary700"
    >
      <VStack
        w={headerContentWidth}
        h="$fit-content"
        alignItems="center"
        justifyContent="center"
        gap="$4"
      >
        <HStack>
          <Text color="$textLight50" fontWeight={500} fontSize="$lg">
            Mesa de Crédito
          </Text>
        </HStack>
        <HStack
          flex={1}
          alignItems="center"
          justifyContent="center"
          w="$full"
          px="$8"
          gap="$2"
        >
          <Input
            light
            width="$full"
            showClear
            name="search"
            onClear={() => {
              setFilters({ text: "" });
              setCurrentValue("");
            }}
            onChange={(value) => {
              setCurrentValue(value);
            }}
            onKeyPress={(e) => {
              // NOTE: When pressed Enter on web
              if (e.keyCode === 13) {
                setFilters({ text: e.target.value });
              }
            }}
            onSubmitEditing={() => {
              // NOTE: When pressed Done/Finish on mobile
              setFilters({ text: currentValue });
            }}
            returnKeyType="done"
            rightIcon={inputSearchRightIcon}
            placeholder="Buscar proposta ou cliente"
          />
        </HStack>
        <HStack width="$fit-content">
          <ScrollView horizontal showsHorizontalScrollIndicator={false}>
            <ButtonGroup
              type="primary"
              onChange={(value) => setFilters({ category: value })}
              options={filterStatusOptions}
              value={filters.category}
            />
          </ScrollView>
        </HStack>
        <HStack alignItems="center" justifyContent="center" gap="$2">
          <Text fontSize="$2xs" color="$primary50" fontWeight={400}>
            Atualizado em 10/12 ás 10:25:00
          </Text>
          <Pressable onPress={onRefresh}>
            <Icon name="refresh" color="white" size={16} />
          </Pressable>
        </HStack>
      </VStack>
    </VStack>
  );
};
